import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'
// 定义props的类型
interface Props {
  content?: string
  width: string
  tooltipContent?: string
}
// 使用withDefaults来给props赋默认值

export default /*#__PURE__*/_defineComponent({
  ...{ name: 'WidgetTooltip' },
  __name: 'index',
  props: {
    content: { default: '' },
    width: { default: '' },
    tooltipContent: { default: '' }
  },
  setup(__props: any) {

const props = __props;


// 使用isShow来控制tooltip是否显示
let isShow = ref<boolean>(true)
// 在span标签上定义一个ref
const contentRef = ref()
const isShowTooltip = function (): void {
  // 计算span标签的offsetWidth与盒子元素的offsetWidth，给isShow赋值
  if (contentRef.value.parentNode.offsetWidth > contentRef.value.offsetWidth) {
    isShow.value = true
  } else {
    isShow.value = false
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    effect: "dark",
    content: props.tooltipContent ? props.tooltipContent : props.content,
    placement: "top",
    disabled: _unref(isShow)
  }, {
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "tooltipContent", {}, () => [
        _createTextVNode(_toDisplayString(props.tooltipContent ? props.tooltipContent : props.content), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "content",
        style: _normalizeStyle({ width: props.width }),
        onMouseover: isShowTooltip
      }, [
        _createElementVNode("span", {
          ref_key: "contentRef",
          ref: contentRef
        }, [
          _renderSlot(_ctx.$slots, "content", {}, () => [
            _createTextVNode(_toDisplayString(props.content), 1)
          ])
        ], 512)
      ], 36)
    ]),
    _: 3
  }, 8, ["content", "disabled"]))
}
}

})